import { Box, Divider, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

import { FlipCard, SectionTitle } from '../../../components'

import { logoTransparent, service1, service2, service3 } from '../../../assets'

import { ScrollFadeInSlideUp } from '../../../components/'

const ServicesWhatWeDo = () => {
  const isSmallScreen = useMediaQuery('(max-width: 762px)'); // Detect screen width
    const whatWeDo = [
        {
            name: 'Buildings',
            subName:'Building construction',
            text:'At Pangu Enterprises, our Building division specializes in the construction and renovation of residential and commercial structures. We deliver high-quality, custom-built homes, multi-family developments, and commercial buildings that reflect functionality, aesthetics, and long-term value. From architectural planning to final finishes, we manage every detail with precision and care—ensuring each project meets the highest standards of craftsmanship, safety, and sustainability.',
            image:service1
        },
        {
            name: 'civil',
            subName:'civil construction',
            text:'Our Civil Construction services focus on the essential infrastructure that supports communities and public spaces. From site preparation and utilities to roadworks, drainage systems, and structural foundations, Pangu Enterprises delivers reliable, safe, and efficient civil works. We work closely with municipalities, engineers, and consultants to ensure all projects meet regulatory standards and serve long-term community needs.',
            image:service2
        },
        {
            name: 'industrial',
            subName:'Industrial Facilities',
            text:'Pangu Enterprises provides specialized construction services for industrial facilities, including warehouses, manufacturing plants, and distribution centers. We design and build durable, high-performance spaces optimized for workflow, safety, and scalability. Our team understands the unique requirements of industrial environments and ensures each project is delivered on time, on budget, and ready for operational success.',
            image:service3
        },
    ]

        const WhatWeDoImage = ({src}) => {
            return (
                <Box
                    component='img'
                    src={src}
                    sx={{
                        objectFit:'cover',
                        width:'50%',
                        '@media screen and (max-width: 762px)':{
                              width:'100%'
                            }
                    }}
                />
            )
        }

        const WhatWeDoText = ({subName, text, index}) => {
          const [firstWord, ...restWords] = subName.split(' ');
            return (
                    <Box
                        sx={{
                            width:'50%',
                            textAlign:index % 2 === 0 ? 'right' :'left',
                            alignContent:'center',
                            padding:'2rem',
                            boxSizing:'border-box',
                            '@media screen and (max-width: 762px)':{
                              width:'100%',
                              padding:'1rem'
                            }
                        }}
                    >
                        <Typography
                          variant="h1"
                          sx={{
                          fontFamily: 'var(--title-font)',
                          fontSize: '2rem',
                          fontWeight: '500',
                          textTransform:'capitalize',
                          paddingY:'2rem'
                          }}
                      >
                          
                          {firstWord + ' '}
                          <span
                          style={{
                              color: 'var(--color-secondary)', // Style for the first word
                              fontWeight: '700', // Example: Make the first word bold
                          }}
                          >
                              {restWords.join(' ')} {/* Join the remaining words */}
                          </span>{' '}
                                                
                        </Typography>
                        <Typography
                            variant='body1'
                            sx={{
                              fontFamily:'var(--text-font)',
                              fontSize:'1.2rem',
                              '@media screen and (max-width:762px)':{
                                textAlign:'center'
                              }
                            }}
                        >{text}</Typography>
                    </Box>
            )
        }

  return (
    <Box
      sx={{
        background:'linear-gradient(to right, #A6A6A6, #fefefe)',
        display:'flex',
        flexDirection:'column'
      }}
    >
        <Box //Logo && brandName
            sx={{
              display:'flex',
              justifyContent:'right',
              marginX:'10rem',
              '@media screen and (max-width: 762px)':{
                marginX:'0'
              }
            }}
          >
            
              <Box // logo
                sx={{
                  width:'5rem',
                  alignContent:'center'
                }}
              >
                <FlipCard>
                <Box
                  component='img'
                  src={logoTransparent}
                  sx={{
                    width: '5rem',
                    display:'flex'
                  }}
                />
                </FlipCard>
              </Box>
            
            <Box
              sx={{
                paddingY:'1rem'
              }}
            >
              <Typography
                variant='h1'
                sx={{
                  fontSize:'2rem',
                  fontFamily:"var(--title-font)",
                  textTransform:'Uppercase',
                  fontWeight:'1000',
                  alignContent:'center',
                  alignItems:'center',
                  letterSpacing:'0.5rem',
                  textAlign:'center',
                  lineHeight:'4rem',
                  fontStretch:'expanded',
                  marginX:'1rem',
                  color:'#000'
                }}
              >
                Pangu
              </Typography>
            </Box>
          </Box>

          <SectionTitle 
            firstTitleWord='What'
            secondTitleWord='We Do'
            textStyle={{
                fontSize:'2rem',
                fontFamily:'var(--title-font)',
                fontWeight:'1000'
            }}
          />

          <Typography
            variant='body1'
            sx={{
                fontFamily:'var(--text-font)',
                fontSize:'1.2rem',
                width:'70%',
                paddingX:'2rem'
            }}
          >
            At Pangu Enterprises, we offer a full range of construction and design services tailored to meet the needs of residential, commercial, industrial, and institutional clients. From concept to completion, we bring expertise, innovation, and quality craftsmanship to every project—delivering results that exceed expectations.
          </Typography>
          
          <Box
            sx={{
              maxWidth:'100%'
            }}
          >
            {whatWeDo.map((item, index) => (
              <ScrollFadeInSlideUp direction='left' threshold='0.5'>
                <Box
                  sx={{
                    maxWidth:'100%'
                  }}
                >
                    <SectionTitle firstTitleWord={item.name} 
                      textStyle={{
                        fontSize:'2.5rem',
                        '@media screen and (max-width: 762px)':{
                          fontSize:'2rem'
                        }
                      }}
                      sx={{
                        paddingY:'1rem',
                        '@media screen and (max-width: 762px)':{
                          paddingY:'2rem'
                        }
                      }}
                      />
                    {isSmallScreen ? (
                      <Box
                        sx={{
                            display:'flex',
                            flexDirection:'column',
                            maxWidth:'100%'
                        }}
                      >
                        <WhatWeDoImage src={item.image}/>
                        <WhatWeDoText 
                            text={item.text}
                            subName={item.subName}
                            index={index}
                        />
                      </Box>
                    ) : (
                    index % 2 === 0 ? (
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row'
                            }}
                        >
                            <WhatWeDoText 
                                text={item.text}
                                subName={item.subName}
                                index={index}
                            />
                            <WhatWeDoImage src={item.image}/>
                        </Box>

                    ):(
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:'row'
                            }}
                        >
                            <WhatWeDoImage src={item.image}/>
                            <WhatWeDoText 
                                text={item.text}
                                subName={item.subName}
                                index={index}
                            />
                        </Box>
                      ))}    
                      <Divider 
                        sx={{
                          marginY:'1rem'
                        }}
                      />
                </ Box>
                </ScrollFadeInSlideUp>
            ))}
            
          </Box>
    </Box>
)}

export default ServicesWhatWeDo